import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 3a9 9 0 1 1 0 18.001A9 9 0 0 1 12 3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 3a9 9 0 1 0 0 18z"
    }, null, -1)
  ]))]))
}
export default { render: render }